<p-dialog
  [(visible)]="visible"
  (onHide)="onHide()"
  [header]="(editMode ? 'waitingList.modal.editTitle' : 'waitingList.modal.newTitle') | translate"
  [modal]="true"
  [style]="{ width: '650px' }"
  [draggable]="false"
  [resizable]="false"
>
  <form [formGroup]="waitingListForm" (ngSubmit)="onSubmit()">
    <div class="flex flex-col gap-4">
      <!-- Búsqueda de Paciente -->
      <div class="flex flex-col gap-2">
        <label for="patient" class="font-semibold">
          {{ 'waitingList.form.patient' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-autoComplete
          id="patient"
          formControlName="patient"
          [suggestions]="filteredPatients"
          (completeMethod)="onPatientSearch($event)"
          (onSelect)="onPatientSelect($event)"
          field="full_name"
          [dataKey]="'patient_id'"
          [dropdown]="false"
          [forceSelection]="true"
          [placeholder]="'waitingList.form.searchPatientPlaceholder' | translate"
          [inputStyle]="{ width: '100%' }"
          styleClass="w-full"
        >
          <ng-template let-patient pTemplate="item">
            <div class="flex items-center gap-2">
              <div class="flex flex-col">
                <span class="font-semibold">{{ patient.first_name }} {{ patient.last_name }}</span>
                <span class="text-sm text-gray-500">{{ patient.email }}</span>
              </div>
            </div>
          </ng-template>
          <ng-template let-patient pTemplate="selectedItem">
            @if (patient) {
              <div>{{ patient.first_name }} {{ patient.last_name }}</div>
            }
          </ng-template>
        </p-autoComplete>
        @if (waitingListForm.get('patient')?.invalid && waitingListForm.get('patient')?.touched) {
          <small class="text-red-500">
            {{ 'waitingList.form.errors.patientRequired' | translate }}
          </small>
        }
      </div>

      <!-- Fechas -->
      <div class="grid grid-cols-2 gap-4">
        <!-- Check-in Deseado -->
        <div class="flex flex-col gap-2">
          <label for="desired_check_in" class="font-semibold">
            {{ 'waitingList.form.checkIn' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <p-datepicker
            id="desired_check_in"
            formControlName="desired_check_in"
            [minDate]="minDate"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            [placeholder]="'waitingList.form.selectDate' | translate"
            appendTo="body"
            styleClass="w-full"
          ></p-datepicker>
          @if (
            waitingListForm.get('desired_check_in')?.invalid &&
            waitingListForm.get('desired_check_in')?.touched
          ) {
            <small class="text-red-500">
              {{ 'waitingList.form.errors.checkInRequired' | translate }}
            </small>
          }
        </div>

        <!-- Check-out Deseado -->
        <div class="flex flex-col gap-2">
          <label for="desired_check_out" class="font-semibold">
            {{ 'waitingList.form.checkOut' | translate }}
            <span class="text-red-500">*</span>
          </label>
          <p-datepicker
            id="desired_check_out"
            formControlName="desired_check_out"
            [minDate]="minDate"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            [placeholder]="'waitingList.form.selectDate' | translate"
            appendTo="body"
            styleClass="w-full"
          ></p-datepicker>
          @if (
            waitingListForm.get('desired_check_out')?.invalid &&
            waitingListForm.get('desired_check_out')?.touched
          ) {
            <small class="text-red-500">
              {{ 'waitingList.form.errors.checkOutRequired' | translate }}
            </small>
          }
        </div>
      </div>

      <!-- Prioridad -->
      <div class="flex flex-col gap-2">
        <label for="priority" class="font-semibold">
          {{ 'waitingList.form.priority' | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-select
          id="priority"
          formControlName="priority"
          [options]="priorities"
          optionLabel="labelKey"
          optionValue="value"
          [placeholder]="'waitingList.form.selectPriority' | translate"
          styleClass="w-full"
        >
          <ng-template let-priority pTemplate="item">
            <div class="flex items-center gap-2">
              <span class="w-3 h-3 rounded-full" [style.background-color]="priority.color"></span>
              <span>{{ priority.labelKey | translate }}</span>
            </div>
          </ng-template>
          <ng-template let-priority pTemplate="selectedItem">
            <span>{{ priority.labelKey | translate }}</span>
          </ng-template>
        </p-select>
      </div>

      <!-- Notas -->
      <div class="flex flex-col gap-2">
        <label for="notes" class="font-semibold">{{ 'waitingList.form.notes' | translate }}</label>
        <textarea
          id="notes"
          formControlName="notes"
          pTextarea
          rows="4"
          [placeholder]="'waitingList.form.notesPlaceholder' | translate"
          class="w-full"
        ></textarea>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-end gap-2 mt-6">
      <p-button
        [label]="'common.cancel' | translate"
        severity="secondary"
        (onClick)="onCancel()"
        [outlined]="true"
      />
      <p-button
        type="submit"
        [label]="(editMode ? 'waitingList.actions.update' : 'waitingList.actions.add') | translate"
        severity="primary"
        [disabled]="waitingListForm.invalid"
      />
    </div>
  </form>
</p-dialog>
